module.exports = __webpack_public_path__ + "static/media/header_slide_07.6da2f71b.jpg";